export const ascLogoOld = `/images/logo.jpeg`;
export const ascLogo = `/images/logo-asc.svg`;
export const ascLogoWhite = `/images/logo-asc-white.svg`;
export const ascLogoPng = `/images/logo-asc.png`;
export const ascLogoFrPng = `/images/logo-asc-fr.png`;
export const ascInsuranceLogo = `/images/logo-insurance-asc.png`;
export const ascInsuranceLogoTransparent = `/images/logo-asc-insurance-transparent.png`;
export const ascInsuranceLogoWhite = `/images/logo-asc-insurance-white.jpg`;

export const visaCard = `/images/visa.svg`;
export const masterCard = `/images/mastercard.svg`;
export const amexCard = `/images/amex.svg`;
export const discoverCard = `/images/discover.svg`;
